export default __webpack_public_path__ + "static/media/Proxy-Delhaize-Grande-Haie-29.e75ea210.jpg";